import type { CollapsibleListData } from 'ricos-schema';
import {
  CollapsibleListData_Direction,
  CollapsibleListData_InitialExpandedItems,
  Node_Type,
} from 'ricos-schema';

import type { NodeBuilder } from './types';
import { isDefined } from './utils';

export const collapsibleList = (...args: (NodeBuilder | CollapsibleListData)[]): NodeBuilder => {
  const collapsibleListData = args.find((a): a is CollapsibleListData => !('type' in a));

  return {
    type: 'block_node',
    node: getId => ({
      id: getId(),
      type: Node_Type.COLLAPSIBLE_LIST,
      nodes: args
        .map(arg => ('type' in arg && arg.type === 'block_node' ? arg.node(getId) : undefined))
        .filter(isDefined),
      collapsibleListData: collapsibleListData
        ? collapsibleListData
        : {
            initialExpandedItems: CollapsibleListData_InitialExpandedItems.FIRST,
            direction: CollapsibleListData_Direction.LTR,
          },
    }),
  };
};

export const collapsibleListItem = (title: NodeBuilder, body: NodeBuilder): NodeBuilder => {
  return {
    type: 'block_node',
    node: getId => ({
      id: getId(),
      type: Node_Type.COLLAPSIBLE_ITEM,
      nodes: [title.node(getId), body.node(getId)],
    }),
  };
};

export const collapsibleListItemTitle = (...args: NodeBuilder[]): NodeBuilder => {
  return {
    type: 'block_node',
    node: getId => ({
      id: getId(),
      type: Node_Type.COLLAPSIBLE_ITEM_TITLE,
      nodes: args.map(arg => arg.node(getId)),
    }),
  };
};

// TODO: restrict which plugins can be added to list item body
export const collapsibleListItemBody = (...args: NodeBuilder[]): NodeBuilder => {
  return {
    type: 'block_node',
    node: getId => ({
      id: getId(),
      type: Node_Type.COLLAPSIBLE_ITEM_BODY,
      nodes: args.map(arg => arg.node(getId)),
    }),
  };
};
